import { create } from "zustand";
import { postLogin } from "../services/httpService";

const useLogin = create((set) => ({
  user: localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null,
  isLoading: false,
  isVerifying: true,
  errorMessage: null,
  login: async (credentials) => {
    set({
      isLoading: true,
      errorMessage: null,
    });
    const { user, error } = await postLogin(credentials);

    set({
      user,
      errorMessage: error,
      isLoading: false,
    });
  },
  logout: () => {
    set({
      user: null,
    });

    localStorage.removeItem("user");
    localStorage.removeItem("token");
  },
}));

export default useLogin;
